import * as React from 'react';

interface ISizeProps {
    size: string;
}

const SizeBox = (props: ISizeProps) => {
    return (
        <div className="sizeBox">{props.size}</div>
    );
};

export default SizeBox;



// WEBPACK FOOTER //
// ./src/modules/SizeBox/SizeBox.tsx